export const isValidDate = (date?: Date | string): boolean => {
  if (!date) return false;
  const parsed = new Date(date);
  // Reject the .NET DateTime min value (0001-01-01)
  return parsed.getFullYear() > 1;
};

const parseDateOnly = (value: Date | string): Date => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const isCurrentSelfDeclarationValid = (date?: Date | string): boolean => {
  if (!date || !isValidDate(date)) return false;
  const today = parseDateOnly(new Date());
  const expiry = parseDateOnly(date);
  expiry.setFullYear(expiry.getFullYear() + 2);
  return expiry >= today;
};

const isExpiringWithinOneMonth = (date: Date | string): boolean => {
  const today = parseDateOnly(new Date());
  const expiry = parseDateOnly(date);
  expiry.setFullYear(expiry.getFullYear() + 2);
  const oneMonthFromNow = parseDateOnly(today);
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
  return expiry >= today && expiry <= oneMonthFromNow;
};

export type SelfDeclarationStatus = 'missing' | 'expired' | 'expiresSoon' | 'delivered';

export const getSelfDeclarationStatus = (
  deliveredDate: Date | string | undefined,
  isDelivered: boolean | undefined,
): SelfDeclarationStatus => {
  if (!isDelivered || !deliveredDate || !isValidDate(deliveredDate)) return 'missing';
  if (!isCurrentSelfDeclarationValid(deliveredDate)) return 'expired';
  if (isExpiringWithinOneMonth(deliveredDate)) return 'expiresSoon';
  return 'delivered';
};
